/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

/**
 * Created by andrea on 2017-06-23.
 */

export class StorageReference {

  private static STORAGE_COMPETITION_IMAGES: string = 'competitionImages';
  private static STORAGE_LOGOS: string = 'logos';

  public static DefaultCompetitionLogo = 'https://firebasestorage.googleapis.com/v0/b/stagespritedemo.appspot.com/o/stageSprite%2Fimages%2Fss_logo.png?alt=media&token=bfa4af3f-cff4-4210-825b-fb5009b18326';

  public static StorageError = {
    NotFound: 'storage/object-not-found',
    Unauthorized: 'storage/unauthorized',
    Cancelled: 'storage/canceled',
    Unknown: 'storage/unknown'
  };

  static getStorageCompetionLogoRef(compId: string) {
    return `${StorageReference.STORAGE_COMPETITION_IMAGES}/${StorageReference.STORAGE_LOGOS}/${compId}`;
  }
}



// WEBPACK FOOTER //
// ./src/shared/StorageReference.ts